var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4606 1.94682C28.7234 2.28487 29.716 3.2773 30.054 4.54017C30.6649 6.82685 30.6673 11.6006 30.6673 11.6006C30.6673 11.6006 30.6673 16.3745 30.054 18.6611C29.716 19.924 28.7234 20.9164 27.4606 21.2544C25.174 21.8678 16.0006 21.8678 16.0006 21.8678C16.0006 21.8678 6.82734 21.8678 4.54065 21.2544C3.27779 20.9164 2.28536 19.924 1.94731 18.6611C1.33398 16.3745 1.33398 11.6006 1.33398 11.6006C1.33398 11.6006 1.33398 6.82685 1.94731 4.54017C2.28536 3.2773 3.27779 2.28487 4.54065 1.94682C6.82734 1.3335 16.0006 1.3335 16.0006 1.3335C16.0006 1.3335 25.174 1.3335 27.4606 1.94682ZM20.6852 11.6011L13.0645 16.0005V7.20151L20.6852 11.6011Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5725cca17c060f9e11f0b10d4ce411c3.svg";
export { ForwardRef as ReactComponent };